import InfoBarMessagePart from './InfoBarMessagePart';
import { InfoBarMessageViewState } from '../schema/InfoBarMessageViewState';
import getInfoBarIcon from '../utils/getInfoBarIcon';
import getInfoBarIconColor from '../utils/getInfoBarIconColor';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logUsage } from 'owa-analytics';
import * as React from 'react';
import { MessagePart } from '../schema/InfoBarMessageViewState';

const styles = require('./InfoBarMessage.scss');
const classNames = require('classnames/bind').bind(styles);

@observer
export default class InfoBarMessage extends React.Component<InfoBarMessageViewState, any> {
    render() {
        const infoBarIconColor = getInfoBarIconColor(this.props.rank, this.props.color);
        const iconName = getInfoBarIcon(this.props.rank);
        const textContainerStyle = classNames(
            styles.textContainer,
            styles.textContainerMarginForNewInfoBarUI,
            this.props.textContainerClassName
        );

        return (
            <div className={classNames(styles.container, styles.newInfoBarUI)}>
                <Icon iconName={iconName} className={classNames(styles.icon, infoBarIconColor)} />
                <div className={textContainerStyle}>
                    {this.props.messageElement
                        ? React.cloneElement(this.props.messageElement, {
                              colorScheme: this.props.colorScheme,
                          })
                        : this.props.messageParts.map((part, index) => {
                              return this.renderMessagePart(part, index);
                          })}
                </div>
            </div>
        );
    }

    private renderMessagePart(part: MessagePart, index: number): JSX.Element {
        if (part) {
            return (
                <span key={index}>
                    <InfoBarMessagePart messagePart={part} colorScheme={this.props.colorScheme} />
                    {index != this.props.messageParts.length - 1 ? ' ' : null}
                </span>
            );
        } else {
            // log empty case datapoint to figure out which message id has this issue and return null
            logUsage('InfoBarMessagePartEmptyCase', [this.props.key]);
            return null;
        }
    }
}
